import axios from "axios";

export const state = {
    loanproducts: [],
};

export const getters = {
    loanproducts: (state) => state.loanproducts,
};

export const mutations = {
    setLoanProducts(state, newValue) {
        state.loanproducts = newValue;
    },
};

export const actions = {
    async fetchLoanProducts({ commit }) {
        await axios.get("/loan-products").then((res) => {
            commit("setLoanProducts", res.data.loan_products);
        });
    },
};
